<section class="join-keys" aria-label="Unir llaves y generar PFX">
  <nav class="dl-progress" aria-label="Progreso unir llaves">
    <div
      class="dl-progress-item"
      [class.is-current]="guideStep === 'archivos'"
      [class.is-done]="guideStep === 'contrasena' || guideStep === 'listo'">
      <span class="dl-progress-num">1</span>
      <span class="dl-progress-label">Archivos</span>
    </div>
    <span class="dl-progress-line" [class.is-done]="guideStep === 'contrasena' || guideStep === 'listo'"></span>
    <div
      class="dl-progress-item"
      [class.is-current]="guideStep === 'contrasena'"
      [class.is-done]="guideStep === 'listo'">
      <span class="dl-progress-num">2</span>
      <span class="dl-progress-label">Contraseña</span>
    </div>
    <span class="dl-progress-line" [class.is-done]="panelPfxListo"></span>
    <div
      class="dl-progress-item"
      [class.is-current]="guideStep === 'listo' && !panelPfxListo"
      [class.is-done]="panelPfxListo">
      <span class="dl-progress-num">3</span>
      <span class="dl-progress-label">Listo</span>
    </div>
  </nav>

  <!-- Éxito -->
  <div class="jk-card jk-success-card" *ngIf="panelPfxListo; else formTpl" role="status" aria-live="polite">
    <div class="jk-success-icon" aria-hidden="true"><i class="fas fa-check"></i></div>
    <div class="jk-success-copy">
      <p class="jk-success-badge">Proceso exitoso</p>
      <h2>¡Tu PFX está listo!</h2>
      <p class="jk-success-lead">
        Guarda el archivo <strong>.pfx</strong> en tu equipo. La descarga se inició automáticamente.
      </p>
      <div class="jk-alert" role="alert" *ngIf="!pfxDescargaDisparada">
        No cierres esta ventana hasta confirmar que tienes el archivo.
      </div>
      <div class="jk-actions">
        <button type="button" class="btn btn-success" *ngIf="!pfxDescargaDisparada" (click)="descargarPfxGenerado()">
          Descargar .pfx
        </button>
        <button type="button" class="btn btn-secondary" *ngIf="pfxDescargaDisparada" (click)="descargarPfxGenerado()">
          Volver a descargar
        </button>
        <button type="button" class="btn btn-success" *ngIf="pfxDescargaDisparada" (click)="irAFirmar()">
          Firmar
        </button>
        <button type="button" class="btn btn-secondary" *ngIf="pfxDescargaDisparada" (click)="reiniciarFormulario()">
          Unir otras llaves
        </button>
      </div>
    </div>
  </div>

  <ng-template #formTpl>
    <form class="jk-card jk-form" [formGroup]="formaForm" (ngSubmit)="onSubmit()">
      <header class="jk-form-head">
        <div class="jk-form-icon" aria-hidden="true"><i class="fas fa-link"></i></div>
        <div class="jk-form-titles">
          <h2>Unir llaves y generar PFX</h2>
          <p>
            Carga <strong class="jk-ink-priv">.key</strong> +
            <strong class="jk-ink-pub">.cer</strong> y define la contraseña del
            <strong>.pfx</strong>.
          </p>
        </div>
      </header>

      <div formArrayName="documentos" class="jk-uploads">
        <div
          *ngFor="let ctrl of documentsDocuments.controls; let i = index"
          class="jk-upload"
          [class.jk-upload--privada]="buttons[i].id === 'keyfile'"
          [class.jk-upload--publica]="buttons[i].id === 'cerfile'"
          [class.jk-upload--listo]="pfxDocumentoListo(i)">
          <div class="jk-upload__head">
            <span class="jk-chip" [class.jk-chip--privada]="buttons[i].id === 'keyfile'" [class.jk-chip--publica]="buttons[i].id === 'cerfile'">
              {{ buttons[i].id === 'keyfile' ? 'Privada' : 'Pública' }}
            </span>
            <span class="jk-upload__title">{{ buttons[i].name }}</span>
            <span class="jk-doc-badge" *ngIf="pfxDocumentoListo(i)">
              <i class="fas fa-check" aria-hidden="true"></i> Listo
            </span>
          </div>
          <div class="jk-dropzone" [class.jk-dropzone--listo]="pfxDocumentoListo(i)">
            <div class="jk-dropzone-row">
              <div class="jk-ico-ring" [style.background-color]="buttons[i].fondo">
                <i class="fas" [class.fa-upload]="!pfxDocumentoListo(i)" [class.fa-check]="pfxDocumentoListo(i)" aria-hidden="true"></i>
              </div>
              <div class="jk-dropzone-meta">
                <span class="jk-dropzone__title">{{ buttons[i].title }}</span>
                <span class="jk-dropzone__sub">{{ buttons[i].subtitle }}</span>
              </div>
            </div>
            <input
              type="file"
              class="jk-file"
              [formControlName]="i"
              [accept]="buttons[i].accept"
              (change)="getFileDetails($any($event.target).files, i)"
              [attr.aria-label]="buttons[i].id === 'keyfile' ? 'Seleccionar archivo .key' : 'Seleccionar archivo .cer'" />
          </div>
          <p class="jk-err" *ngIf="validateformats[i] || isValidFieldInArray(documentsDocuments, i)">{{ error[i] }}</p>
        </div>
      </div>

      <div
        class="jk-docs-resumen"
        [class.jk-docs-resumen--completo]="pfxArchivosListosCount === totalCantidad"
        aria-live="polite">
        <div
          class="jk-docs-resumen__track"
          role="progressbar"
          [attr.aria-valuenow]="pfxArchivosListosCount"
          aria-valuemin="0"
          [attr.aria-valuemax]="totalCantidad">
          <div class="jk-docs-resumen__fill" [style.width.%]="(pfxArchivosListosCount / totalCantidad) * 100"></div>
        </div>
        <span class="jk-docs-resumen__label">{{ pfxArchivosListosCount }}/{{ totalCantidad }} archivos</span>
      </div>

      <div class="jk-pass-block">
        <div class="jk-pass-fields">
          <div class="jk-pass-col">
            <label class="jk-label" for="jk-pass">Contraseña del PFX *</label>
            <div class="jk-pass-wrap">
              <input
                id="jk-pass"
                class="jk-input"
                [type]="peekContrasena ? 'text' : 'password'"
                placeholder="Clave"
                formControlName="contrasena"
                maxlength="12"
                autocomplete="new-password"
                [class.is-invalid]="camposvalidos('contrasena')"
                aria-describedby="jk-pass-requirements" />
              <button
                type="button"
                class="jk-pass-peek"
                [class.is-active]="peekContrasena"
                aria-label="Mostrar contraseña"
                (pointerenter)="peekContrasena = true"
                (pointerleave)="peekContrasena = false">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="jk-pass-col">
            <label class="jk-label" for="jk-pass2">Confirmar *</label>
            <div class="jk-pass-wrap">
              <input
                id="jk-pass2"
                class="jk-input"
                [type]="peekContrasenaConfirmacion ? 'text' : 'password'"
                placeholder="Repetir clave"
                formControlName="contrasenaConfirmacion"
                maxlength="12"
                autocomplete="new-password"
                [class.is-invalid]="camposvalidos('contrasenaConfirmacion')" />
              <button
                type="button"
                class="jk-pass-peek"
                [class.is-active]="peekContrasenaConfirmacion"
                aria-label="Mostrar confirmación"
                (pointerenter)="peekContrasenaConfirmacion = true"
                (pointerleave)="peekContrasenaConfirmacion = false">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </div>
            <p class="jk-err" *ngIf="!contrasenaIguales && passwordHasInput">No coincide.</p>
          </div>
        </div>

        <div id="jk-pass-requirements" class="jk-pass-panel" role="region" aria-label="Requisitos de la contraseña">
          <div class="jk-pass-panel__head">
            <span class="jk-pass-panel__title">Requisitos</span>
            <span class="jk-pass-panel__chip" [class.is-done]="passwordRulesMetCount === 5">
              {{ passwordRulesMetCount }}/5
            </span>
          </div>
          <div
            class="jk-pass-panel__track"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="5"
            [attr.aria-valuenow]="passwordRulesMetCount"
            [attr.aria-valuetext]="passwordRulesSummaryLabel">
            <div class="jk-pass-panel__fill" [style.width.%]="passwordRulesProgressPercent"></div>
          </div>
          <ul class="jk-pass-rules">
            <li
              *ngFor="let rule of passwordRuleStates"
              class="jk-pass-rule"
              [class.is-met]="rule.met"
              [class.is-warn]="!rule.met && passwordHasInput">
              <i
                class="fas"
                [class.fa-check-circle]="rule.met"
                [class.fa-circle]="!rule.met"
                aria-hidden="true"></i>
              <span>{{ rule.label }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="jk-footer">
        <span class="jk-footnote">* Obligatorio</span>
        <button type="submit" class="btn btn-primary" [disabled]="!puedeGenerarCertificado || generando">
          <span *ngIf="!generando">Generar PFX</span>
          <span *ngIf="generando"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Generando…</span>
        </button>
      </div>
    </form>
  </ng-template>
</section>
